import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const AskAIApi = createApi({
  reducerPath: "AskAIApi",
  tagTypes: ["askai", "askai-history"],
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_CHAT_API_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("accessToken", localStorage.getItem("accessToken") || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    generateDesignDocs: builder.mutation({
      query: (payload) => ({
        url: `api/agents/task-refiner/generate-text `,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["askai"],
    }),
  }),
});

export const { useGenerateDesignDocsMutation } = AskAIApi;
